<button class='tokens-select' type='button' (click)='open($event)' [disabled]='disabled'>
  <div class='token'>
    <img loading='lazy' class='icon' [src]='image' [alt]='nameAlt' width='18' height='18' (error)='onIconError($event)'>
    <span class='symbol'>{{ symbol }}</span>
  </div>
  <img class='arrow' src='/assets/icons/arrow-down-button.svg' alt='arrow' width='20' height='20' />
</button>
